import React, { useEffect, useState } from 'react';
import MainLayout from '../main-layout/main-layout';
import { useParams } from "react-router-dom";
import { HelpVisorPresenter } from '../../presenters/screens/help-visor.presenter'

interface RouteParams {
    docs: string;
}

const HelpVisor = () => {
    const presenter = new HelpVisorPresenter();
    const params: RouteParams = useParams();
    const [iframeSrc, setIframeSrc] = useState<string | null>(null);

    useEffect(() => {
        if (params.docs) {
            console.log(params.docs)
            const [site, uniqueId] = params.docs.split(':');

            const newUrl = `https://ayudaenaccion.sharepoint.com/sites/${site}/_layouts/15/Embed.aspx?UniqueId=${uniqueId}`;

            setIframeSrc(newUrl);
        }

        presenter.initialize()
    }, [params.docs])

    return (
        <MainLayout>
            <div style={{ width: '100%', height: '100vh' }}>
                {iframeSrc ? (
                    <iframe
                        src={iframeSrc}
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        title="PDF Viewer"
                    />
                ) : (
                    <p>No PDF file selected</p>
                )}
            </div>
        </MainLayout>

    );
};

export default HelpVisor;
